import React, { useState } from "react"; // Added useState
import { NavLink } from "react-router-dom";
import {  Modal, ModalHeader, ModalBody, ModalFooter,  FormGroup, Label, Input, Button, Row, Col,  Alert} from "reactstrap"; // Added Reactstrap components
import { useAuth } from "../Context/AuthenticateProvider";
import UserIcon from '../Assets/images/user.png';
import Logo from '../Assets/images/logo.png';
import { getCookie } from "../Helpers/Utils"; 
import { loadingTrue, loadingFalse } from "../Reducer/loaderSlice";
import { useDispatch } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";

const Sidebar = ({ isOpen, toggleSidebar }) => {
    const { logOut } = useAuth();
    const dispatch = useDispatch();

    // --- Modal States ---
    const [reportModal, setReportModal] = useState(false);
    const [reportDates, setReportDates] = useState({ from_date: "", to_date: "" });

    const userData = getCookie("user_data") ? JSON.parse(getCookie("user_data")) : null;
    const userRole = userData?.role || 'staff';
    const token = getCookie("token");

    // --- Excel Export Function ---
    const handleExportExcel = async () => {
        if (!reportDates.from_date || !reportDates.to_date) {
            return toast.error("Please select both dates");
        }

        dispatch(loadingTrue());
        try {
            const response = await axios({
                url: `https://muthaiah-cotton.qads.co.in/cotton-mill/purchase/purchase_history.php?from_date=${reportDates.from_date}&to_date=${reportDates.to_date}`,
                // url: `http://localhost/cotton-mill/purchase/purchase_history.php?from_date=${reportDates.from_date}&to_date=${reportDates.to_date}`,
                method: 'GET',
                responseType: 'blob', // Important for file downloads
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            // Create a link to download the file
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Purchase_History_${reportDates.from_date}_to_${reportDates.to_date}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            
            setReportModal(false);
            toast.success("Excel exported successfully!");
        } catch (err) {
            toast.error("Failed to export report. Check date range.");
        } finally {
            dispatch(loadingFalse());
        }
    };

    const menuGroups = [
        {
            title: "Home",
            items: [
                { path: "/dashboard", label: "Dashboard", icon: "bx-grid-alt", hidden: userRole === 'staff' },
                // { path: "/inventory/report", label: "Inventory", icon: "bx-store", hidden: userRole === 'staff' },
                { path: "/creditnotes/report", label: "Credit Notes", icon: "bx-note", hidden: userRole === 'staff' },
                // { path: "/invoices/report", label: "Invoices", icon: "bx-receipt", hidden: userRole === 'staff' },
                { path: "/payments/report", label: "Payments", icon: "bx-money", hidden: userRole === 'staff' },
                { path: "/profitloss/report", label: "Profit / Loss", icon: "bx-bar-chart", hidden: userRole === 'staff' },
                { path: "/purchases/report", label: "Purchases", icon: "bx-bar-chart", hidden: userRole === 'staff' },
                { path: "/salary/report", label: "Salary", icon: "bx-bar-chart", hidden: userRole === 'staff' },
                { path: "/staff/report", label: "Staff Wallet", icon: "bx-wallet", hidden: userRole === 'staff' },
                { path: "/sales/report", label: "Sales", icon: "bx-bar-chart", hidden: userRole === 'staff' },
            ].filter(item => !item.hidden)
        },
        // --- NEW REPORT SECTION ---
        {
            title: "Reports",
            items: [
                { 
                    label: "Purchase Excel", 
                    icon: "bx-file", 
                    onClick: () => setReportModal(true), // Opens Modal
                    isButton: true 
                },
            ],
            hidden: userRole === 'staff'
        },
        {
            title: "Staff Management",
            items: [
                { path: "/staffs", label: "Staffs", icon: "bx-group" },
                { path: "/staffs/add", label: "Add Staff", icon: "bx-user-plus" },
            ],
            hidden: userRole === 'staff'
        },
        {
            title: "Salary Management",
            items: [
                { path: "/salary", label: "Salary", icon: "bx-list-plus" },
                { path: "/salary/add", label: "Add Salary", icon: "bx-user-plus" },
            ],
            hidden: userRole === 'staff'
        },
        {
            title: "Farmers Management",
            items: [
                { path: "/farmers", label: "Farmers", icon: "bx-leaf" },
                { path: "/farmers/add", label: "Add Farmer", icon: "bx-user-plus" },
            ],
        },
        {
            title: "Invoice Management",
            items: [
                { path: "/invoices", label: "Invoices", icon: "bx-receipt" },
                { path: "/invoices/add", label: "Add Invoice", icon: "bx-user-plus" },
            ],
            hidden: userRole === 'staff'
        },
        {
            title: "TDS Management",
            items: [
                { path: "/tds", label: "TDS", icon: "bx-receipt" },
                { path: "/tds/add", label: "Add TDS", icon: "bx-user-plus" },
            ],
            hidden: userRole === 'staff'
        },
        {
            title: "Payments Management",
            items: [
                { path: "/payments", label: "Payments", icon: "bx-money" },
                { path: "/payments/add", label: "Add Payment", icon: "bx-user-plus" },
                { path: "/creditnotes", label: "Credit Notes", icon: "bx-note" },
                { path: "/creditnotes/add", label: "Add Credit Note", icon: "bx-user-plus" },
            ],
            hidden: userRole === 'staff'
        },
        {
            title: "Deposit Management",
            items: [
                { path: "/deposit", label: "Staff Deposits", icon: "bx-money" },
                { path: "/deposit/add", label: "Add Staff Deposit", icon: "bx-user-plus" },
            ],
            hidden: userRole === 'staff'
        },
        {
            title: "Purchase Management",
            items: [
                { path: "/purchases", label: "Purchases", icon: "bx-shopping-bag" },
                { path: "/purchases/add", label: "Add Purchase", icon: "bx-user-plus", },
                { path: "/purchases/pay", label: "Pay Purchase", icon: "bx-rupee", },
                { path: "/purchases/paylist", label: "Pay Purchase List", icon: "bx-rupee", },
            ].filter(item => !item.hidden)
        },
        {
            title: "Expenses Management",
            items: [
                { path: "/expenses", label: "Expenses", icon: "bx-wallet" },
                { path: "/expenses/admin", label: "Add Admin Expense", icon: "bx-user-plus", hidden: userRole === 'staff' },    
            ].filter(item => !item.hidden)
        },
        {
            title: "Agent Management",
            items: [
                { path: "/agent-pay", label: "Agent Payments", icon: "bx-money" },
                { path: "/agent-pay/add", label: "Add Agent Payment", icon: "bx-user-plus" },
            ],
            hidden: userRole === 'staff'
        },
        {
            title: "Product Management",
            items: [
                { path: "/products", label: "Products", icon: "bx-package" },
                { path: "/products/add", label: "Add Product", icon: "bx-user-plus" },
            ],
            hidden: userRole === 'staff'
        },
        {
            title: "Client Management",
            items: [
                { path: "/clients", label: "Clients", icon: "bx-user-pin" },
                { path: "/clients/add", label: "Add Client", icon: "bx-user-plus" },
                { path: "/sub-clients", label: "Sub-clients", icon: "bx-user-pin" },
                { path: "/sub-clients/add", label: "Add Sub-client", icon: "bx-user-plus" },
            ],
            hidden: userRole === 'staff'
        },
        {
            title: "Vehicle Management",
            items: [
                { path: "/vehicles", label: "Vehicles", icon: "bx-car" },
                { path: "/vehicles/add", label: "Add Vehicle", icon: "bx-user-plus" },
            ],
            hidden: userRole === 'staff'
        },
        {
            title: "System",
            items: [
                { path: "/calculator", label: "Calculator", icon: "bx-cog" },
            ],
            hidden: userRole === 'staff'
        }
    ];

    const filteredMenuGroups = menuGroups.filter(group => !group.hidden);

    return (
        <aside className={`app-sidebar ${isOpen ? "open" : ""}`}>
            <div className="sidebar-header">
                <div className="d-flex align-items-center">
                    <img src={Logo} alt="Logo" className="sidebar-logo" />
                    <h5 className="sidebar-title ms-2 mb-0" style={{ fontSize: '1.1rem', fontWeight: '700' }}>
                        Muthiah Cotton
                    </h5>
                </div>
                <button className="mobile-close" onClick={toggleSidebar}>
                    <i className="bx bx-x"></i>
                </button>
            </div>

            <div className="sidebar-scroll">
                {filteredMenuGroups?.map((group, index) => (
                    <div key={index} className="sidebar-group">
                        <div className="sidebar-section-title">{group.title}</div>
                        <div className="inventory-menus">
                            {group?.items?.map((item, i) => (
                                item.isButton ? (
                                    // Custom button for Modal Trigger
                                    <div key={i} className="menu-item pointer" onClick={item.onClick}>
                                        <i className={`bx ${item.icon}`}></i>
                                        <span>{item.label}</span>
                                    </div>
                                ) : (
                                    <NavLink
                                        key={i}
                                        to={item.path}
                                        end
                                        className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}
                                        onClick={() => window.innerWidth < 1024 && toggleSidebar()}
                                    >
                                        <i className={`bx ${item.icon}`}></i>
                                        <span>{item.label}</span>
                                    </NavLink>
                                )
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            {/* 🔥 EXCEL EXPORT MODAL 🔥 */}
            <Modal isOpen={reportModal} toggle={() => setReportModal(false)} centered>
                <ModalHeader toggle={() => setReportModal(false)} className="bg-success text-white border-0">
                    Export Purchase History
                </ModalHeader>
                <ModalBody className="p-4">
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label className="small fw-bold">From Date</Label>
                                <Input 
                                    type="date" 
                                    value={reportDates.from_date} 
                                    onChange={(e) => setReportDates({...reportDates, from_date: e.target.value})} 
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label className="small fw-bold">To Date</Label>
                                <Input 
                                    type="date" 
                                    value={reportDates.to_date} 
                                    onChange={(e) => setReportDates({...reportDates, to_date: e.target.value})} 
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Alert color="info" className="small mt-2 border-0">
                        <i className="bx bx-info-circle me-1"></i> Data will be downloaded as a CSV file compatible with Excel.
                    </Alert>
                </ModalBody>
                <ModalFooter className="border-0">
                    <Button color="secondary" outline onClick={() => setReportModal(false)}>Cancel</Button>
                    <Button color="success" className="fw-bold px-4" onClick={handleExportExcel}>
                        <i className="bx bx-download me-1"></i> Download Excel
                    </Button>
                </ModalFooter>
            </Modal>

            <div className="sidebar-footer">
                <div className="user-info">
                    <img src={UserIcon} alt="user" />
                    <div className="user-details">
                        <p className="u-name text-capitalize">{userData?.name || "User"}</p>
                        <p className="u-email">{userData?.email || "user@gmail.com"}</p>
                    </div>
                </div>
                <button className="logout-btn-new" onClick={logOut}>
                    <i className="bx bx-log-out"></i> Logout
                </button>
            </div>
        </aside>
    );
};

export default Sidebar;